import React from 'react'

export const CalendarTodayIcon = ({
  width = 28,
  height = 28
}: {
  width?: number
  height?: number
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
      fill="#282828"
    />
    <path
      d="M12.4536 15.12C12.4536 12.06 14.6836 9.41999 14.6836 9.41999L11.2636 9.46999V8.06999H16.4136V9.47999C16.4136 9.47999 14.1636 12.34 14.1636 15.12H12.4536Z"
      fill="#282828"
    />
    <path
      d="M8.79294 15.12V9.66L7.60294 9.99V8.75L9.45294 8H10.4129V15.12H8.79294Z"
      fill="#282828"
    />
  </svg>
)
